import { render } from "./Notifications.vue?vue&type=template&id=4c2e9e50"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
script.render = render

export default script